import StackAPI from '../../../lib/StackAPI'
import Article from '../types/Article'
import dayjs from '../../../lib/dayjs'
import { captureException } from '@sentry/react'

const ENDPOINT = '/api/partners/articles'
const DEFAULT_LIMIT = 50
const DEFAULT_OFFSET = 0

type Params = {
  start: Date
  end: Date
  partnerType: string
  partnerId?: number
  publisherId?: number
  limit?: number
  offset?: number
}

type RequestParams = { [key: string]: number | string | undefined }

const formatDateRange = (params: Params) => {
  const startOfDay = dayjs(params.start)
    .startOf('day')
    .subtract(6, 'day')
    .toISOString()
  const endOfDay = dayjs(params.end).endOf('day').add(6, 'day').toISOString()
  return `${startOfDay},${endOfDay}`
}

const addFilters = (params: Params, requestParams: RequestParams) => {
  requestParams['filter[status]'] = 2
  requestParams['filter[published_range]'] = formatDateRange(params)

  switch (params.partnerType) {
    case 'affiliate':
      requestParams['filter[affiliate_id]'] = params.partnerId
      break
    case 'publisher':
      requestParams['filter[publisher_id]'] = params.partnerId
      break
  }
  requestParams.include = params.partnerType
}

const addPagination = (params: Params, requestParams: RequestParams) => {
  requestParams['page[limit]'] = params.limit || DEFAULT_LIMIT
  requestParams['page[offset]'] = params.offset || DEFAULT_OFFSET
}

const addSort = (_: Params, requestParams: RequestParams) => {
  requestParams.sort = 'published_at'
}

export const getArticles = async (params: Params): Promise<Article[]> => {
  const { get } = StackAPI()
  const requestParams: RequestParams = {}

  addFilters(params, requestParams)
  addPagination(params, requestParams)
  addSort(params, requestParams)

  return await get({ path: ENDPOINT, params: requestParams })
    .then(({ status, data }) => (status === 200 ? data.data : []))
    .catch((error) => {
      captureException(error, { extra: { params } })
      return []
    })
}
